export default __webpack_public_path__ + "static/media/right_slightly_highArch.9ecb9aca.png";